import {connect} from "react-redux";
import axios from "axios";
import PanelLayout from "../components/PanelLayout";
import React, {useState, useLayoutEffect} from 'react';
import getAxiosConfig from "../../../utils/axiosConfig";
import ABTestInputPortList from "../components/ABTest/ABTestInputPortList";
import urlList from "../../../reducers/propertiesReducer";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import {showToastForBackend, showToastForFrontend} from "../../../actions/toastActions";
import messageCodes from "../../../utils/messageCodes";

const ABTestPanel = (props) => {
    const [segmentationMap, setSegmentationMap] = useState(new Map());

    useLayoutEffect(()  => {
        axios
            .get(urlList().segmentationUrl + "/getAllSegmentationDefinitions", getAxiosConfig())
            .then(response => {
                const newMap = new Map()
                Object.keys(response.data).forEach((key) => newMap.set(key, response.data[key]));
                setSegmentationMap(newMap)
            })
            .catch(error => {
                if (error.response)
                    props.showToastForBackend(error.response.data);
                else
                    props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
            })
    }, []);

    return (
        <PanelLayout>
            <ABTestInputPortList segmentationMap={segmentationMap} clickedNodeAction={props.clickedNodeAction}/>
        </PanelLayout>
    );
}

function mapStateToProps(state) {
    return {
        contextProperties: state.contextProperties,
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {clickedNodeAction, showToastForFrontend, showToastForBackend})(ABTestPanel);